import { create } from 'zustand';
import { clearAllDrafts } from '../utils/kycDraft';

export const useAuthStore = create((set) => ({
  user: null,
  tokens: null,
  isAuthenticated: false,
  isInitializing: true,
  loading: false,
  // True when a request failed with an unrecoverable 401 (token expired and
  // refresh failed). Drives the global "session timed out" modal.
  sessionExpired: false,

  setUser: (user) => set({ user }),
  setTokens: (tokens) => set({ tokens }),
  setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
  setInitializing: (isInitializing) => set({ isInitializing }),
  setLoading: (loading) => set({ loading }),

  // Remember the role so we can route to the right login screen after a session
  // expires (survives a page reload, unlike the in-memory store).
  triggerSessionExpired: () => set({ sessionExpired: true }),
  clearSessionExpired: () => set({ sessionExpired: false }),

  login: (user, tokens) => {
    if (user?.role) localStorage.setItem('user_role', user.role);
    set({
      user,
      tokens,
      isAuthenticated: true,
      isInitializing: false,
      loading: false,
      sessionExpired: false,
    });
  },

  logout: () => {
    localStorage.removeItem('user_role');
    // Half-finished KYC drafts hold photographs of an ID. Whoever uses this
    // device next is somebody else as far as we can tell, and they must not be
    // offered the chance to resume into them.
    clearAllDrafts();
    set({
      user: null,
      tokens: null,
      isAuthenticated: false,
      isInitializing: false,
      loading: false,
      sessionExpired: false,
    });
  },
}));

export const useBookingStore = create((set) => ({
  bookings: [],
  selectedBooking: null,
  loading: false,

  setBookings: (bookings) => set({ bookings }),
  setSelectedBooking: (booking) => set({ selectedBooking: booking }),
  setLoading: (loading) => set({ loading }),

  addBooking: (booking) => set((state) => ({
    bookings: [booking, ...state.bookings],
  })),
}));

export const usePropertyStore = create((set) => ({
  properties: [],
  selectedProperty: null,
  loading: false,

  setProperties: (properties) => set({ properties }),
  setSelectedProperty: (property) => set({ selectedProperty: property }),
  setLoading: (loading) => set({ loading }),
}));

export const useUIStore = create((set) => ({
  isMobileMenuOpen: false,
  isPropertyModalOpen: false,
  isBookingModalOpen: false,
  selectedDateRange: null,

  setMobileMenuOpen: (isOpen) => set({ isMobileMenuOpen: isOpen }),
  setPropertyModalOpen: (isOpen) => set({ isPropertyModalOpen: isOpen }),
  setBookingModalOpen: (isOpen) => set({ isBookingModalOpen: isOpen }),
  setSelectedDateRange: (range) => set({ selectedDateRange: range }),
}));
